import api from "./api";

function authHeaders(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

const agentBillsService = {
  getAgents: async (token) => {
    const res = await api.get("/agent-bills/agents", authHeaders(token));
    return res.data;
  },

  getSummaries: async (token, params = {}) => {
    const res = await api.get("/agent-bills/summaries", {
      params,
      ...authHeaders(token),
    });
    return res.data;
  },

  getAgent: async (token, agentId) => {
    const res = await api.get(`/agent-bills/agents/${agentId}`, authHeaders(token));
    return res.data;
  },

  getMine: async (token) => {
    const res = await api.get("/agent-bills/me", authHeaders(token));
    return res.data;
  },

  createPayment: async (token, payload) => {
    const res = await api.post("/agent-bills/payments", payload, authHeaders(token));
    return res.data;
  },
};

export default agentBillsService;
